<div class="multi-input-control">
  <div
    *ngFor="
      let control of controlArray.controls;
      let i = index;
      let first = first;
      let last = last
    "
    class="multi-input-control"
  >
    <mat-form-field>
      <mat-label *ngIf="label">{{ label }}</mat-label>
      <input matInput [placeholder]="placeholder" [formControl]="control" />
      <button
        type="button"
        aria-label="Remove"
        (click)="remove(i)"
        class="link"
        matSuffix
        *ngIf="!(last && first) && control.status !== 'DISABLED'"
      >
        <i class="material-icons remove-field-button">close</i>
      </button>
      <mat-hint *ngIf="last && tooltip" align="start" [matTooltip]="tooltip">
        <a (click)="(null)" class="link">
          {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
        </a>
      </mat-hint>
      <mat-hint
        *ngIf="
          last &&
          ((!!maxFields && controlArray.length < maxFields) || !maxFields) &&
          !disableAdd
        "
        align="end"
      >
        <button type="button" (click)="add()" class="link" aria-label="Add">
          {{ addText | translate }}
        </button>
      </mat-hint>
      <mat-error *ngIf="isErrorState(control)">
        {{ itemErrorOutput(control) }}
      </mat-error>
    </mat-form-field>
    <div class="print">
      <div class="label">{{ placeholder | translate }}:</div>
      <div class="answer">{{ control.value }}</div>
    </div>
  </div>
  <span class="multi-input-control__error" *ngIf="isErrorState(controlArray)">
    {{ errorOutput(controlArray) }}
  </span>
</div>
